import React from "react";
import { Div, Image } from "../index";
import Empty_Image from "../../../Assets/images/Empty_Data.png";

const EmptyData = (props) => {
  return (
    <Div
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={props.height ? props.height : "auto"}
      padding={props.height ? "0" : "50px 0"}
    >
      <Image
        loading="lazy"
        height={props.width ? props.width : "235px"}
        width={props.width ? props.width : "235px"}
        src={Empty_Image}
        alt="No Data Found ..!"
      />
    </Div>
  );
};

export default EmptyData;
